export const SectionHeading = ({ eyebrow, title, description, align = "center", light = false }) => (
  <div className={`mb-12 max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`} data-testid="section-heading">
    {eyebrow && (
      <p className={`text-xs font-semibold uppercase tracking-widest ${light ? "text-emerald-400" : "text-emerald-600"}`}>
        {eyebrow}
      </p>
    )}
    <h2 className={`mt-3 font-heading text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl ${light ? "text-white" : "text-navy-900"}`}>
      {title}
    </h2>
    {description && (
      <p className={`mt-4 text-base leading-relaxed ${light ? "text-slate-300" : "text-slate-600"}`}>{description}</p>
    )}
  </div>
);
